import { AssignmentFormItem, RelatedEmployeeFilter } from 'domain/shared/compliance';
import { ACTIVE_STATUS as ACTIVE_EMPLOYEE_STATUS, DISMISSED_STATUS, RELOCATION_STATUS } from 'domain/shared/employee';
import { AssignmentIdsByAudience } from './types';
import { DEFAULT_ACTIVE_CONTRACT_TYPES } from './constants';
import { Filter } from 'framework/list';

export const splitAssignmentIdsByAudience = (assignments: AssignmentFormItem[]): AssignmentIdsByAudience =>
  assignments.reduce<AssignmentIdsByAudience>(
    (result, assignment) => {
      const normalizedAssignmentId = String(assignment.id);

      if (assignment.account) {
        result.relatedAccountIds.push(normalizedAssignmentId);
      } else {
        result.relatedProjectIds.push(normalizedAssignmentId);
      }

      return result;
    },
    {
      relatedProjectIds: [],
      relatedAccountIds: [],
    },
  );

export const getUniqueStringValues = (values: Array<string | number | null | undefined>): string[] =>
  Array.from(new Set(values.filter(value => value !== null && value !== undefined).map(String)));

export const buildAudienceEmployeeSearchFilter = (
  relatedEmployeeFilter?: Nullable<RelatedEmployeeFilter>,
  relatedEmployeeContractTypes?: string[] | null,
): Filter => {
  const employeeFilter: Filter = {
    'specification:employeesByActiveContractType': {
      in: relatedEmployeeContractTypes?.length ? relatedEmployeeContractTypes : DEFAULT_ACTIVE_CONTRACT_TYPES,
    },
    workingStatus: {
      in: [ACTIVE_EMPLOYEE_STATUS, DISMISSED_STATUS, RELOCATION_STATUS],
    },
  };
  const officeIds = relatedEmployeeFilter?.officeId?.in || [];
  const positionIds = relatedEmployeeFilter?.positionId?.in || [];
  const businessRegistrationCountries = relatedEmployeeFilter?.businessRegistrationCountry?.in || [];

  if (officeIds.length) {
    employeeFilter['specification:office'] = {
      in: officeIds,
    };
  }

  if (positionIds.length) {
    employeeFilter['position.id'] = {
      in: positionIds,
    };
  }

  if (businessRegistrationCountries.length) {
    employeeFilter['specification:businessRegistrationCountry'] = {
      in: businessRegistrationCountries,
    };
  }

  return employeeFilter;
};
